import styled, { css } from 'styled-components';

import { AspectRatioImage } from '@/components/AspectRatioImage/AspectRatioImage';
import { Box } from '@/components/Box';
import { Typography } from '@/components/Typography';
import { px2rem } from '@/theme';

export const FreeTextContentBox = styled(Box)`
  p {
    font-family: ${({ theme }) => theme.fonts.paragraphFont};
  }
`;

export const SubTitle = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.subtitleFont};
`;

export const StyledImageMobile = styled(AspectRatioImage)`
  ${({ theme }) => css`
      display: block;
    ${theme.media.md.up} {
      display: none;
  `}
`;
export const ImageWrapperDeskTop = styled(Box)`
  ${({ theme }) => css`
      display: none;
  ${theme.media.md.up} {
      display: flex;
      justify-content: center;
  `}
`;
export const StyledImageDeskTop = styled(AspectRatioImage)`
  ${({ theme }) => css`
      display: none;
    ${theme.media.md.up} {
      display:block;
  `}
`;
export const StyledParagraph = styled(Typography)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(1.75)};
    margin-bottom: ${theme.spacing(1.75)};
    font-family: ${theme.fonts.paragraphFont};
    color: ${theme.colors.default};
    text-align: left;
    ${theme.media.sm.up} {
      text-align: justify;
    }
  `}
`;

export const StyledParagraphCustom = styled(Typography)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(1.75)};
    margin-bottom: ${theme.spacing(1.75)};
    font-family: ${theme.fonts.paragraphFont};
    color: ${theme.colors.default};
    text-align: left;
    display: inline;
    ${theme.media.sm.up} {
      text-align: justify;
    }
  `}
`;
export const StyledButton = styled.button`
  background: none;
  font-size: 0.875rem;
  text-decoration: underline;
  border: none;
  cursor: pointer;
  padding: 0;
`;
export const StyledEm = styled.em`
  font-style: italic;
`;
export const StyledOl = styled.ol`
  padding-bottom: ${({ theme }) => theme.spacing(1)};
  counter-reset: list-counter;

  li {
    position: relative;
    display: flex;
    align-items: baseline;
    counter-increment: list-counter;

    &::before {
      content: counter(list-counter) '.';
      ${({ theme }) => css`
        top: ${theme.spacing(1)};
        margin-inline: ${px2rem(5, 10)};
        font-size: inherit;
      `}
    }
  }
`;
